var createAxisDelta = function () {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
};
var createDelta = function () {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
};
var createAxis = function () {
  return {
    min: 0,
    max: 0
  };
};
var createBox = function () {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
export { createAxis, createAxisDelta, createBox, createDelta };